import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

// API returns role as: "SaasAdmin" | "PropertyOwner" | "Tenant"
// Use those exact strings in allowedRoles
// e.g. <ProtectedRoute allowedRoles={["SaasAdmin"]}> 

const ROLE_HOME = {
  SaasAdmin:     "/admin/dashboard",
  PropertyOwner: "/owner/dashboard",
  Tenant:        "/tenant/dashboard",
};

const ProtectedRoute = ({ allowedRoles, children }) => {
  const { user } = useAuth();

  // Not logged in → go to login
  if (!user) return <Navigate to="/" replace />;

  // Wrong role → redirect to their own dashboard
  if (!allowedRoles.includes(user.role)) {
    return <Navigate to={ROLE_HOME[user.role] || "/login"} replace />;
  }

  return children;
};

export default ProtectedRoute;